import React from 'react';
import { Trophy, Target, BookOpen } from 'lucide-react';
import { Card } from '../ui/Card';
import { ProgressBar } from '../ui/Progress';
import { UserStats } from '../../types';
interface ProgressSummaryCardProps {
  stats: UserStats;
  masteredCount: number;
  totalModules: number;
  streak?: number; // Made optional since we don't display it anymore
  totalQuestionsAnswered?: number;
}
export function ProgressSummaryCard({
  stats,
  masteredCount,
  totalModules,
  totalQuestionsAnswered = 0
}: ProgressSummaryCardProps) {
  const progressToNextLevel = stats.xp % 250 / 250 * 100;
  const xpToNextLevel = 250 - stats.xp % 250;
  return <Card className="p-5 border-slate-200/60 shadow-sm" data-id="element-428">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 divide-y md:divide-y-0 md:divide-x divide-slate-100" data-id="element-429">
        {/* Level & XP */}
        <div className="flex items-center gap-4 md:pr-4" data-id="element-430">
          <div className="w-12 h-12 rounded-2xl bg-indigo-50 flex items-center justify-center text-indigo-600 ring-4 ring-indigo-50/50" data-id="element-431">
            <Trophy className="w-6 h-6" data-id="element-432" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-433">
            <div className="flex justify-between items-end mb-1.5" data-id="element-434">
              <span className="text-sm font-bold text-slate-700 uppercase tracking-wider" data-id="element-435">
                Level {stats.level}
              </span>
              <span className="text-xs text-indigo-600 font-bold bg-indigo-50 px-2 py-0.5 rounded-full" data-id="element-436">
                {stats.xp} XP
              </span>
            </div>
            <ProgressBar value={progressToNextLevel} height={6} color="bg-indigo-500" data-id="element-437" />
            <p className="text-[10px] text-slate-400 mt-1.5 font-medium" data-id="element-438">
              Nog {xpToNextLevel} XP tot level {stats.level + 1}
            </p>
          </div>
        </div>

        {/* Modules Mastered */}
        <div className="flex items-center gap-4 md:px-4 pt-4 md:pt-0" data-id="element-439">
          <div className="w-12 h-12 rounded-2xl bg-emerald-50 flex items-center justify-center text-emerald-600 ring-4 ring-emerald-50/50" data-id="element-440">
            <Target className="w-6 h-6" data-id="element-441" />
          </div>
          <div data-id="element-442">
            <div className="text-2xl font-bold text-slate-900 leading-none mb-1" data-id="element-443">
              {masteredCount}
              <span className="text-slate-400 text-lg font-normal ml-1" data-id="element-444">
                / {totalModules}
              </span>
            </div>
            <div className="text-xs text-slate-500 font-medium uppercase tracking-wide" data-id="element-445">
              Vakken beheerst
            </div>
          </div>
        </div>

        {/* Total Questions Answered */}
        <div className="flex items-center gap-4 md:pl-4 pt-4 md:pt-0" data-id="element-446">
          <div className="w-12 h-12 rounded-2xl bg-blue-50 flex items-center justify-center text-blue-600 ring-4 ring-blue-50/50" data-id="element-447">
            <BookOpen className="w-6 h-6" data-id="element-448" />
          </div>
          <div data-id="element-449">
            <div className="text-2xl font-bold text-slate-900 leading-none mb-1" data-id="element-450">
              {totalQuestionsAnswered}
            </div>
            <div className="text-xs text-slate-500 font-medium uppercase tracking-wide" data-id="element-451">
              Vragen geoefend
            </div>
          </div>
        </div>
      </div>
    </Card>;
}